import React from 'react'
import { TextInput } from '@/modules/base/components/inputs'
import { dispatch } from '@/redux/ducks/lists'
import { updateDocument } from '@/redux/ducks/document/drawer'
import DocumentReadOnlyField from './read-only'
import OCRWrapper from '@/modules/document/components/file-info/ocr-wrapper'
import customDecodeUri from '@/utils/customDecodeUri'
import { EXTERNAL_OWNER_SYSTEMS } from '@/modules/file/constants'
import { useAppSelector } from '@/redux/store'

interface DocumentTextInputProps {
  label: string,
  value: string,
  hideEmpty?: boolean,
  placeholder?: string,
  readOnly?: boolean,
  ocrKey?: string,
  name?: string,
  customClass?: object | string,
  formatter?: { (v: string): string }
  isOcrValue?: boolean
}

const DocumentTextInput = (props: DocumentTextInputProps) => {
  const document = useAppSelector((state) => state.document.drawer.document)

  const {
    isAssigned,
    metaData,
    externalOwnerSystem,
  } = document

  const { customClass, label, value, ocrKey, name, readOnly, formatter, placeholder, hideEmpty, isOcrValue } = props

  if (hideEmpty && !value && isAssigned) return null

  if (isAssigned || externalOwnerSystem === EXTERNAL_OWNER_SYSTEMS.desktop) {
    return <DocumentReadOnlyField formatter={formatter} label={label} value={customDecodeUri(value)} customClass={customClass} />
  }

  return (
    <OCRWrapper isOcrValue={isOcrValue} ocr={metaData?.ocr} ocrKey={ocrKey} valueKey={name}
      className={customClass}>
      <TextInput
        placeholder={placeholder}
        readOnly={readOnly}
        name={name}
        className={customClass}
        useFormik={false}
        label={label}
        value={value}
        onBlur={(value) => dispatch(updateDocument({ value, key: name }))}
        onChange={(value) => dispatch(updateDocument({ value, key: name }))}
      />
    </OCRWrapper>
  )
}

export default DocumentTextInput
